import { ZoomControl } from "react-leaflet"

import MouseCoordinates from "@/features/map/MouseCoordinates.jsx"
import MinimapControl from "@/features/map/MinimapControl.jsx"
import MyLatlngGraticule from "@/features/map/plugins/MyLatlngGraticule.jsx"
import MyTerminator from "@/features/map/plugins/MyTerminator.jsx"
import MyPolylineMeasure from "@/features/map/plugins/MyPolylineMeasure.jsx"

// Per Toggle schaltbare Karten-Controls und -Dekorationen.
// NmScale bleibt in MainComponent: muss vor der LayersControl mounten,
// damit die Control-Reihenfolge in der bottomright-Ecke stimmt.
export default function MapControls({ toggleFlags }) {
  return (
    <>
      {!toggleFlags.includes("Terminator") ? null : <MyTerminator />}
      {!toggleFlags.includes("ZoomControl") ? null : (
        <ZoomControl position="bottomright" zoomInText="+" zoomOutText="-" />
      )}
      {!toggleFlags.includes("Graticule") ? null : <MyLatlngGraticule />}
      {!toggleFlags.includes("Minimap") ? null : (
        <MinimapControl position="topright" />
      )}
      {!toggleFlags.includes("LatLon") ? null : (
        <div
          key={"MouseCoordinates outer div"}
          className={`leaflet-top leaflet-right mouse_coordinates-offset`}
        >
          <MouseCoordinates key={"MouseCoordinates"} />
        </div>
      )}
      {!toggleFlags.includes("PolylineMeasure") ? null : <MyPolylineMeasure />}
    </>
  )
}
